import React from 'react';
import PropTypes from 'prop-types';
import LinkLayout from '../LinkLayout';

function MoviesQuotes(props) {
  return (
    <LinkLayout
      title={'Movies Quotes'}
      subtitle={'5 movie quote cards'}></LinkLayout>
  );
}
MoviesQuotes.propTypes = {};

MoviesQuotes.defaultProps = {};
export default MoviesQuotes;
